import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import LanguageOption from '../../Components/Header/LanguageOption/LanguageOption';
import { useLanguage } from '../../Contexts/LanguageContext';
import LoginOption from '../../Components/LoginOption/LoginOption';
import LoginLinksData from '../../Data/LoginLinks';
import './SplashScreen.scss';

const SplashScreen = ({onValidationSuccess }) => {
  const [otp, setOtp] = useState(['', '', '', '']);
  const inputRefs = useRef([]);

  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  const formTitle = data.lockScreen.title;
  const buttonText = data.lockScreen.buttonText;

  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value === '' && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (value !== '' && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleVerify = () => {
    const otpNumber = otp.join('');
    if (otpNumber.length !== 4 || isNaN(otpNumber)) {
      document.querySelector('.error-msg').innerText = 'Please enter a valid 4-digit number.';
      return;
    }

    // Assume the correct OTP is '1234', replace with your desired OTP
    if (otpNumber === '1234') {
      // Navigate to next screen (replace this with your navigation logic)
      console.log('Navigate to next screen');
      onValidationSuccess();
    } else {
      // alert('Incorrect OTP. Please enter the correct OTP.');
      document.querySelector('.error-msg').innerText = 'Incorrect OTP. Please enter the correct OTP.';
    }
  };

  return (
    <>
      <div className="container">
        <div className='splash-screen-header'>
           <div className='header-action-buttons'>
              <Link className="custom-btn-secondary login-button" to="https://tenant.focalx.ai/" target="_blank">
                Login
              </Link>
              {/* <LoginOption options={LoginLinksData} /> */}
              {/* <LanguageOption /> */}
            </div>          
        </div>
        <div className='splash-screen-container'>
          <div className="logo">
            <img className="focalx-logo" src='/Assets/images/vascor-logo.svg' alt='VASCOR Logo' />
          </div>
          <div className='splash-screen-card'>
            <div className='form'>
              <h2>{formTitle}</h2>
              <div className="otp-input-container">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    className="otp-input"
                    ref={(el) => (inputRefs.current[index] = el)}
                  />
                ))}
              </div>
              <div className='error-msg text-danger'></div>
              <div className="action-btn-wrap">
                <button
                  id="contact-submit"
                  type="button"
                  className="custom-btn custom-btn-primary"
                  onClick={handleVerify}
                >
                  {buttonText}
                </button>
              </div>
            </div>            
          </div>
        </div>
      </div>
    </>
  );
}

export default SplashScreen;
